import '../assets/scss/vendor.scss';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import {CurrencyPipe} from '@angular/common';
import { BrowserModule, Title } from '@angular/platform-browser';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { MomentModule } from 'angular2-moment';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { NgbDateParserFormatter, NgbDatepickerConfig} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ChartsModule } from 'ng2-charts';
import { ClickOutsideModule } from 'ng-click-outside';
import { NgxCurrencyModule } from "ngx-currency";
import { AdminComponent } from './admin/admin.component';
import { AppComponent } from './app.component';
import { TaskComponent } from './task/task.component';
import { NavbarComponent } from './navbar/navbar.component';
import { GlobalSearchComponent } from './global-search/global-search.component';
import { HelpComponent } from './help/help.component';
import { UserNotificationComponent } from './user-notification/user-notification.component';
import { AppointmentComponent } from './appointment/appointment.component';
import { InnerNavComponent } from './inner-nav/inner-nav.component';
import { ReportsComponent } from './reports/reports.component';
import { LeftNavComponent } from './left-nav/left-nav.component';
import {
  WorkRequirementSharedModule,
  DateValidationDirective,
  AutofocusDirective,
  DateMinMaxValidationDirective,
} from './shared';
import {
  NgMultiSelectDropDownDirective
} from './shared/directives/ngMultiSelectDropDown.directive';
import {
  NumericDirective
} from './shared/directives/number.directive';

import { NonComplianceComponent } from './non-compliance/non-compliance.component';
import { PersonSummaryComponent } from './person-summary/person-summary.component';
import { AssessmentSummaryComponent } from './assessment-summary/assessment-summary.component';
import { PaymentSummaryComponent } from './payment-summary/payment-summary.component';
import { RequestPaymentComponent } from './request-payment/request-payment.component';
import { PaymentDetailsComponent } from './payment-details/payment-details.component';
import { LoginComponent } from './login/login.component';
import { DateUtility, TimeUtility, CommonUtility, TokenStorage, NgbDateCustomParserFormatter } from './shared';
import { ReferenceTableService } from './reference-table.service';
import { Interceptor } from "./shared/request-inteceptor";
import { ServerConstantsService, AuthService, DataService, FieldValidationDirective, FieldInitializationDirective,RestrictInputDirective,
  AgGridUtility, ModalPopUp } from './shared';
import { EligibilitySummaryComponent } from './eligibility-summary/eligibility-summary.component';
import { HouseholdSummaryComponent } from './household-summary/household-summary.component';
import { ReportSummaryComponent } from './report-summary/report-summary.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProviderDashboardComponent } from './provider-dashboard/provider-dashboard.component';
import { FederalReportsComponent } from './federal-reports/federal-reports.component';
import { NonComplianceSummaryComponent } from './non-compliance-summary/non-compliance-summary.component';
import { SessionTimeoutModal } from './shared/modals/sessionTimeout.component';
import { SessionWarningModal } from './shared/modals/sessionWarning.component';
import { ChatbotModule } from './chatbot/chatbot.module';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { CreateTaskComponent } from './task/create-task.component';
import {AdminLeftNavComponent} from "./admin/admin-left-nav/admin-left-nav.component";
import {ApplicationConfigurationComponent} from "./application-configuration/applicationConfiguration.component";
import {ProviderManagementComponent} from "./provider-management/provider-management.component";
import {ProviderService} from "./provider-management/provider-management.service";
import {NgMultiSelectDropDownModule} from "ng-multiselect-dropdown";
import { CorrespondenceComponent } from './correspondence/correspondence.component';
import { PersonInformationComponent } from './person-information/person-information.component';

import {AnnouncementsComponent} from "./Announcements/announcements.component";
import {AnnouncementService} from "./Announcements/announcements.service";
import { ManualCorrespondenceComponent } from './manual-correspondence/manual-correspondence.component';
import { AppointmentHistoryComponent } from './appointment-history/appointment-history.component';
import {AgGridModule} from "ag-grid-angular";
import { SkillComponent } from './skill/skill.component';
import { CaseNotesSummaryComponent } from './case-notes-summary/case-notes-summary.component';
import { CaseNotesComponent } from './case-notes/case-notes.component';
import { AccessControlSummaryComponent } from './access-control-summary/access-control-summary.component';
import { AccessControlDetailsComponent } from './access-control-details/access-control-details.component';
import { EducationCertificationComponent } from './education-certification/education-certification.component';
import { TestScoreComponent } from './test-score/test-score.component';
import { BarriersComponent } from './barriers/barriers.component';
import { WorkHistoryComponent } from './work-history/work-history.component';
import { EmploymentPlanComponent } from './employment-plan/employment-plan.component';
import { EmploymentPlanSummaryComponent } from './employment-plan-summary/employment-plan-summary.component';

import { NumericEditorComponent} from "./shared/components/numeric-editor.component";
import { HoursEditorComponent} from "./shared/components/hours-editor.component";
import { CurrencyEditorComponent} from "./shared/components/currency.component";
import { BootstrapDatePickerComponent } from "./shared/components/ng-date-picker.component";
import { TextEditorComponent} from "./shared/components/text-editor.component";
import { YearEditorComponent} from "./shared/components/year-editor.component";
import { TextEditor50Component} from "./shared/components/text-editor-max-len-50.component";

import { ContactHistoryComponent } from './contact-history/contact-history.component';
import { ContactComponent } from './contact/contact.component';
import {ContactDetailsComponent} from "./contact-details/contact-details.component";
import { ComponentSummaryComponent } from './component-summary/component-summary.component';
import { ComponentDetailsComponent } from './component-details/component-details.component';
import { ReviewRecommendationComponent } from './review-recommendations/review-recommendations.component';
import { TrackComponentComponent } from './track-component/track-component.component';
import { ComponentOverallProgressComponent } from './component-overall-progress/component-overall-progress.component';
import { ServiceProviderComponent } from './service-provider/service-provider.component';
import { EmploymentSummaryComponent } from './employment-summary/employment-summary.component';
import { EnrollmentSummaryComponent } from './enrollment-summary/enrollment-summary.component';
import { AnnouncementsSummaryComponent } from './announcements-summary/announcements-summary.component';
import { EmploymentPlanAuditComponent } from './employment-plan-audit/employment-plan-audit.component';
import { ReimbursementsComponent } from './reimbursements/reimbursements.component';
import { ReimbursementsSummaryComponent } from './reimbursements-summary/reimbursements-summary.component';
import { StaffManagementComponent } from './staff-management/staff-management.component';
import { StaffManagementSummaryComponent } from './staff-management-summary/staff-management-summary.component';
import { AdminProviderSummaryComponent } from './admin-provider-summary/admin-provider-summary.component';
import { AdminProviderDetailsComponent } from './admin-provider-details/admin-provider-details.component';
import { AdminProviderCountyComponent } from './admin-provider-county/admin-provider-county.component';
import { AdminProviderOfficeComponent } from './admin-provider-office/admin-provider-office.component';
import { WorkerDashboardComponent } from './worker-dashboard/worker-dashboard.component';
import { AdminAnnouncementSummaryComponent } from './admin-announcement-summary/admin-announcement-summary.component';
import { AdminAnnouncementDetailsComponent } from './admin-announcement-details/admin-announcement-details.component';
import { HeaderNavComponent } from './header-nav/header-nav.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { PasswordStrengthBarModule } from 'ng2-password-strength-bar';
import { UniverseLeftNavComponent } from './universe-left-nav/universe-left-nav.component';
import { CanDeactivateGuard, CanDeactivateGuardService } from "./shared/modals/modal-popup/can-deactivate-gaurd.service";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ModalPopupService } from "./shared/modals/modal-popup/modal-popup.service";
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { from } from 'rxjs/observable/from';
import { LoaderComponent } from './loader/loader.component';
import { RefferalHistoryComponent } from './refferal-history/refferal-history.component';
import { RedirectComponent } from './redirect/redirect.component';
import { TaskSummaryComponent } from './task-summary/task-summary.component';
import { LoginDhsComponent } from './login-dhs/login-dhs.component';
import { ErrorComponent } from './error/error.component';
import { ComparableWorkfareComponent } from './comparable-workfare/comparable-workfare.component';
import { ProgressbarComponent } from './progressbar/progressbar.component';
import { DeleteComponent } from './delete/delete.component';
import { GridviewComponent } from './gridview/gridview.component';
import { InputrendererComponent } from './inputrenderer/inputrenderer.component';
import {NgxMaskModule, IConfig} from 'ngx-mask';
import { UploadComponent } from './upload/upload.component';
import { EmploymentTrainingRetentionComponent } from './employment-training-retention/employment-training-retention.component'
import { PyramidChartComponent } from './pyramid-chart/pyramid-chart.component';
import { GroupedBarChartComponent } from './grouped-barchart/grouped-barchart.component'
import { MonthlySnapshotDetailsComponent } from './monthly-snapshot-details/monthly-snapshot-details.component'
import { MonthlySnapshotRollupComponent } from './monthly-snapshot-rollup/monthly-snapshot-rollup.component'
import { ComponentActivityReportComponent} from './component-activity-report/component-activity-report.component'
import { PotentialCandidatesReportComponent } from './potential-candidates-report/potential-candidates-report.component';
import { ValidationDirective } from './validation.directive';
import { FnsreportComponent } from './fnsreport/fnsreport.component';
import { Fnsreport2Component } from './fnsreport2/fnsreport2.component';
import { Fnsreport3Component } from './fnsreport3/fnsreport3.component';
import { Fnsreport4Component } from './fnsreport4/fnsreport4.component';
import { AriesTaskReportComponent } from './aries-task-report/aries-task-report.component';
import { ProviderDeterminationComponent } from './provider-determination/provider-determination.component';
import { EnrollmentDetailComponent } from './enrollment-detail/enrollment-detail.component';


/* Load Server Constants */
export const ServerConstantsFactory = (serverConstants: ServerConstantsService) => {
  return () => {
    return serverConstants.loadConstants();
  };
};
export const customCurrencyMaskConfig = {
  align: "left",
  allowNegative: false,
  allowZero: true,
  decimal: ".",
  precision: 2,
  prefix: "$ ",
  suffix: "",
  thousands: ",",
  nullable: true
};

/* Module Definition */
@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    TaskComponent,
    NavbarComponent,
    GlobalSearchComponent,
    HelpComponent,
    UserNotificationComponent,
    AppointmentComponent,
    InnerNavComponent,
    ReportsComponent,
    LeftNavComponent,
    NonComplianceComponent,
    PersonSummaryComponent,
     PersonSummaryComponent,
    AssessmentSummaryComponent,
    PaymentSummaryComponent,
    RequestPaymentComponent,
    PaymentDetailsComponent,
    LoginComponent,
    EligibilitySummaryComponent,
    HouseholdSummaryComponent,
    PaymentDetailsComponent,
    ReportSummaryComponent,
    DashboardComponent,
    ProviderDashboardComponent,
    FieldValidationDirective,
    FieldInitializationDirective,
    AutofocusDirective,
    DateMinMaxValidationDirective,
    RestrictInputDirective,
    NgMultiSelectDropDownDirective,
    FederalReportsComponent,
    NonComplianceSummaryComponent,
    SessionTimeoutModal,
    SessionWarningModal,
    CreateTaskComponent,
    DateValidationDirective,
    AdminLeftNavComponent,
    ApplicationConfigurationComponent,
    ProviderManagementComponent,
    AnnouncementsComponent,
    ProviderManagementComponent,
    CorrespondenceComponent,
    PersonInformationComponent,
    ManualCorrespondenceComponent,
    AppointmentHistoryComponent,
    SkillComponent,
    CaseNotesSummaryComponent,
    CaseNotesComponent,
    AccessControlSummaryComponent,
    AccessControlDetailsComponent,
    EducationCertificationComponent,
    TestScoreComponent,
    BarriersComponent,
    WorkHistoryComponent,
    EmploymentPlanComponent,
    EmploymentPlanSummaryComponent,
    NumericEditorComponent,
    HoursEditorComponent,
    CurrencyEditorComponent,
    BootstrapDatePickerComponent,
    TextEditorComponent,
    YearEditorComponent,
    ContactHistoryComponent,
    ContactDetailsComponent,
    ContactComponent,
    ContactComponent,
    TextEditor50Component,
    ComponentSummaryComponent,
    ComponentDetailsComponent,
    ReviewRecommendationComponent,
    TrackComponentComponent,
    ComponentOverallProgressComponent,
    ServiceProviderComponent,
    EmploymentSummaryComponent,
    EnrollmentSummaryComponent,
    ServiceProviderComponent,
    AnnouncementsSummaryComponent,
    EmploymentPlanAuditComponent,
    ReimbursementsComponent,
    ReimbursementsSummaryComponent,
    StaffManagementComponent,
    StaffManagementSummaryComponent,
    AdminProviderSummaryComponent,
    AdminProviderDetailsComponent,
    AdminProviderCountyComponent,
    AdminProviderOfficeComponent,
    WorkerDashboardComponent,
    AdminAnnouncementSummaryComponent,
    AdminAnnouncementDetailsComponent,
    HeaderNavComponent,
    ResetPasswordComponent,
    UniverseLeftNavComponent,
    ModalPopUp,
    ForgotPasswordComponent,
    LoaderComponent,
    RefferalHistoryComponent,
    RedirectComponent,
    TaskSummaryComponent,
    LoginDhsComponent,
    ErrorComponent,
    ComparableWorkfareComponent,
    ProgressbarComponent,
    DeleteComponent,
    GridviewComponent,
    InputrendererComponent,
    UploadComponent,
    EmploymentTrainingRetentionComponent,
    PyramidChartComponent,
    GroupedBarChartComponent,
    MonthlySnapshotDetailsComponent,
    MonthlySnapshotRollupComponent,
    ComponentActivityReportComponent,
    PotentialCandidatesReportComponent,
    AriesTaskReportComponent,
    NumericDirective,
    ValidationDirective,
    FnsreportComponent,
    Fnsreport2Component,
    Fnsreport3Component,
    Fnsreport4Component,
    ProviderDeterminationComponent,
    EnrollmentDetailComponent,
  ],
  imports: [
    BrowserModule,
    WorkRequirementSharedModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ChartsModule,
    ChatbotModule,
    ClickOutsideModule,
    PasswordStrengthBarModule,
    BrowserAnimationsModule,
    MomentModule,
    NgIdleKeepaliveModule.forRoot(),
    SimpleNotificationsModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
    NgbModule.forRoot(),
    NgxMaskModule.forRoot(),
    AgGridModule.withComponents([NumericEditorComponent,CurrencyEditorComponent,BootstrapDatePickerComponent,TextEditorComponent,YearEditorComponent,TextEditor50Component,HoursEditorComponent,GridviewComponent,ProgressbarComponent,DeleteComponent,InputrendererComponent])
  ],
  providers: [
    Title,
    NgbActiveModal,
    DateUtility,
    TimeUtility,
    CommonUtility,
    ReferenceTableService,
    TokenStorage,
    ServerConstantsService,
    AuthService,
    DataService,
    { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true },
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
    { provide: APP_INITIALIZER, useFactory: ServerConstantsFactory, multi: true, deps: [ServerConstantsService] },
    NgbDatepickerConfig,
    ProviderService,
    AnnouncementService,
    AgGridUtility,
    CurrencyPipe,
    CanDeactivateGuard,
    ModalPopupService,
    CanDeactivateGuardService
  ],
  entryComponents: [SessionTimeoutModal, ModalPopUp, SessionWarningModal,LoaderComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts